/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChainTransactionInfoResponse
 */
export interface ChainTransactionInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionInfoResponse
     */
    txHash: string;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionInfoResponse
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionInfoResponse
     */
    time: number;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionInfoResponse
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionInfoResponse
     */
    fee: string;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionInfoResponse
     */
    nonce: number;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionInfoResponse
     */
    method: string;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionInfoResponse
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionInfoResponse
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionInfoResponse
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionInfoResponse
     */
    raw: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChainTransactionInfoResponse
     */
    status: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionInfoResponse
     */
    errorMessage: string;
}

export function ChainTransactionInfoResponseFromJSON(json: any): ChainTransactionInfoResponse {
    return ChainTransactionInfoResponseFromJSONTyped(json, false);
}

export function ChainTransactionInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainTransactionInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'txHash': json['txHash'],
        'timestamp': json['timestamp'],
        'time': json['time'],
        'height': json['height'],
        'fee': json['fee'],
        'nonce': json['nonce'],
        'method': json['method'],
        'from': json['from'],
        'to': json['to'],
        'amount': json['amount'],
        'raw': json['raw'],
        'status': json['status'],
        'errorMessage': json['errorMessage'],
    };
}

export function ChainTransactionInfoResponseToJSON(value?: ChainTransactionInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'txHash': value.txHash,
        'timestamp': value.timestamp,
        'time': value.time,
        'height': value.height,
        'fee': value.fee,
        'nonce': value.nonce,
        'method': value.method,
        'from': value.from,
        'to': value.to,
        'amount': value.amount,
        'raw': value.raw,
        'status': value.status,
        'errorMessage': value.errorMessage,
    };
}


